<template>
    <el-dialog custom-class="del_coll_dialog" :model-value="show" title="删除收件人" width="422px" destroy-on-close :lock-scroll="false" @close="handleClose" @open="handleOpen">
        <div class="validate_dialog_content">
            <div class="close" @click="handleClose">
                <Close class="icon" />
            </div>
            <div class="title_iocn"><i class="iconfont icon-shanchu"></i></div>
            <h1>删除收件人</h1>
            <h2>{{ row.recipientName }}（{{ row.email }}）</h2>
            <div class="btn_box" v-loading="loading">
                <button @click="handleClose">我再想想</button>
                <button @click="submit">确认删除</button>
            </div>
        </div>
    </el-dialog>
</template>

<script setup>
import { ref } from "vue";
import { Close } from "@element-plus/icons-vue";
import { apiRecipientDelete } from "@/request/api";

const props = defineProps({
    show: { type: Boolean, default: false },
    row: { type: Object, default: {} },
});
const emits = defineEmits(["close", "refresh"]);

const loading = ref(false);

async function submit() {
    loading.value = true;
    try {
        const { code } = await apiRecipientDelete({ id: props.row.id });
        if (code !== "0") return;
        handleClose();
        emits("refresh");
    } finally {
        loading.value = false;
    }
}
// 打开
function handleOpen() {}

// 关闭
function handleClose() {
    emits("close");
}
</script>

<style lang="scss">
.del_coll_dialog {
    border-radius: 16px;
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        padding: 0;
    }
    .validate_dialog_content {
        padding: 34px;
        position: relative;
        text-align: center;
        .close {
            position: absolute;
            top: 32px;
            right: 32px;
            cursor: pointer;
            .icon {
                width: 24px;
                height: 24px;
            }
        }
        .title_iocn {
            width: 68px;
            height: 68px;
            border-radius: 8px;
            background-color: #ff5a00;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            .iconfont {
                color: #fff;
                font-size: 24px;
            }
        }
        h1 {
            color: #2a2a2a;
            font-size: 24px;
            line-height: 28px;
            margin-top: 24px;
            font-weight: 400;
        }
        h2 {
            color: #727272;
            font-size: 14px;
            line-height: 28px;
            margin-top: 16px;
            font-weight: 400;
            padding: 0 27px;
            span {
                color: #2a2a2a;
            }
        }
        .btn_box {
            padding-top: 48px;
            display: flex;
            justify-content: space-between;
            button {
                width: 168px;
                height: 68px;
                border-radius: 8px;
                font-size: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                &:first-child {
                    background-color: var(--week-primary-color);
                    color: #fff;
                }
                &:last-child {
                    background-color: #f5f5f5;
                    color: #2a2a2a;
                }
                span {
                    font-size: inherit;
                }
            }
        }
    }
}
</style>
